import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type GetNotificationGroupSubscriptionVariables = Types.Exact<{
  scope: Types.NotificationGroupScopeInput;
}>;


export type GetNotificationGroupSubscription = { __typename?: 'Subscription', notificationGroup?: { __typename?: 'NotificationGroupUnopenedCountUpdatePayload', timestamp: string, notificationGroups: { __typename?: 'NotificationGroupConnection', totalCount: number, nodes: Array<{ __typename?: 'NotificationGroupAccessRequestApproved', id: string } | { __typename?: 'NotificationGroupAccessRequestDenied', id: string } | { __typename?: 'NotificationGroupAccessRequestSubmitted', id: string } | { __typename?: 'NotificationGroupAssetAssignedToYou', id: string } | { __typename?: 'NotificationGroupAssetStatusChanged', id: string } | { __typename?: 'NotificationGroupCommentCreated', id: string } | { __typename?: 'NotificationGroupCommentCreatedShareAccess', id: string } | { __typename?: 'NotificationGroupFileUploaded', id: string } | { __typename?: 'NotificationGroupReplyCreated', id: string } | { __typename?: 'NotificationGroupReplyCreatedShareAccess', id: string } | { __typename?: 'NotificationGroupRequesterAccessRequestApproved' } | { __typename?: 'NotificationGroupRequesterAccessRequestDenied' } | { __typename?: 'NotificationGroupTranscriptCompletedSelf', id: string } | { __typename?: 'NotificationGroupTransferBatchCompleted', id: string } | { __typename?: 'NotificationGroupTransferBatchCompletedSelf', id: string } | { __typename?: 'NotificationGroupUserMentioned', id: string } | { __typename?: 'NotificationGroupUserMentionedShareAccess', id: string }> } } | null };


export const GetNotificationGroup = /*#__PURE__*/ gql`
    subscription GetNotificationGroup($scope: NotificationGroupScopeInput!) {
  notificationGroup(scope: $scope) {
    ... on NotificationGroupUnopenedCountUpdatePayload {
      timestamp
      notificationGroups {
        nodes {
          ... on NotificationGroupCommentCreated {
            id
          }
          ... on NotificationGroupFileUploaded {
            id
          }
          ... on NotificationGroupReplyCreated {
            id
          }
          ... on NotificationGroupTransferBatchCompleted {
            id
          }
          ... on NotificationGroupTransferBatchCompletedSelf {
            id
          }
          ... on NotificationGroupUserMentioned {
            id
          }
          ... on NotificationGroupAssetAssignedToYou {
            id
          }
          ... on NotificationGroupAssetStatusChanged {
            id
          }
          ... on NotificationGroupTranscriptCompletedSelf {
            id
          }
          ... on NotificationGroupAccessRequestSubmitted {
            id
          }
          ... on NotificationGroupAccessRequestApproved {
            id
          }
          ... on NotificationGroupAccessRequestDenied {
            id
          }
          ... on NotificationGroupCommentCreatedShareAccess {
            id
          }
          ... on NotificationGroupReplyCreatedShareAccess {
            id
          }
          ... on NotificationGroupUserMentionedShareAccess {
            id
          }
        }
        totalCount
      }
    }
  }
}
    ` as unknown as DocumentNode<GetNotificationGroupSubscription, GetNotificationGroupSubscriptionVariables>;

          

          export const useGetNotificationGroupSubscription = (options?:SubscriptionHookOptions<GetNotificationGroupSubscription, GetNotificationGroupSubscriptionVariables>) => useSubscription(GetNotificationGroup, options);

          

          export type GetNotificationGroupSubscriptionOptions = SubscriptionHookOptions<GetNotificationGroupSubscription, GetNotificationGroupSubscriptionVariables>;

          

          export type GetNotificationGroupSubscriptionResult = ReturnType<typeof useGetNotificationGroupSubscription>;

          
